<template>
  <MountingTimeslotRegistrations
    :model-value="null"
    variant="pending"
    :all="true"
  />
</template>

<script lang="tsx" setup>
import MountingTimeslotRegistrations
  from '@pages/mountings/mounting/timeslots/MountingTimeslotRegistrations.vue';
</script>

<style lang="scss" scoped>
</style>
